var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'custom-background': _vm.customerBackground == true },attrs:{"id":"app"}},[(_vm.isLogin != null &&
    _vm.$route.fullPath.includes('doom_yoga') &&
    _vm.isCustomer == null
    )?_c('DoOmYogaHome'):((_vm.isLogin != null &&
    _vm.$route.fullPath.includes('doom_yoga') &&
    _vm.isCustomer == 'true') ||
    (_vm.isLogin == null &&
      _vm.$route.fullPath.includes('doom_yoga') &&
      _vm.$route.name == 'DoOmYogaCustomerHome') ||
    (_vm.isLogin == null &&
      _vm.$route.fullPath.includes('doom_yoga') &&
      _vm.$route.name == 'DoOmYogaCustomerEventsCalendar')
    )?_c('DoOmYogaCustomerIndex'):(_vm.isLogin != null && _vm.$route.fullPath.includes('my_irish_date'))?_c('MIDHome'):(_vm.isLogin != null && _vm.$route.fullPath.includes('doorder'))?_c('DoorderHome'):(_vm.isLogin != null && _vm.$route.fullPath.includes('garden_help') && _vm.user_type == 'admin')?_c('GardenHelpHome'):(_vm.isLogin != null && _vm.$route.fullPath.includes('garden_help') && _vm.user_type == 'operator')?_c('GardenHelpContractorHome'):(_vm.isLogin != null && _vm.$route.fullPath.includes('garden_help') && _vm.user_type == 'user')?_c('GardenHelpCustomerHome'):(_vm.isLogin != null &&
    _vm.$route.fullPath.includes('astrology') &&
    _vm.isCustomer == null
    )?_c('AstrologyHome'):((_vm.isLogin != null &&
    _vm.$route.fullPath.includes('astrology') &&
    _vm.isCustomer == 'true') ||
    (_vm.isLogin == null &&
      _vm.$route.fullPath.includes('astrology') &&
      _vm.$route.name == 'AstrologyCustomerHome') ||
    (_vm.isLogin == null &&
      _vm.$route.fullPath.includes('astrology') &&
      _vm.$route.name == 'AstrologyCustomerCreateBirthChartIndex')
    )?_c('AstrologyCustomerIndex'):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7c88296","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 